import {
  defineComponent,
  computed,
  ref,
  watch,
  onMounted,
  getCurrentInstance,
  ComponentInternalInstance,
} from 'vue-demi';
import { useState } from './hooks';
import HeaderStepNew from 'src/components/header-step-new.vue';
import Popup from 'src/components/popup/popup-new.vue';
import { getLeadAdsProtocal, signLeadAdsProtocal } from './../../service/index';
import { getDraft } from './../objective/state';
import store from './../../store/index';
import globalLoading from './../../components/loading/global';
import { setPolling } from './../../utils/polling';
import { customBizReport } from './../../utils/errorLogger';
import teaTracker, { trackEvent } from './../../tea-tracker';
import { paymethodTypeMap, TeaConfigPayment } from './../../const/payment';
import CreationFooter from 'src/components/creation-footer.vue';
import PopupChosen from 'src/components/popup-chosen.vue';
import { OptimizeGoalOptionsForBudget } from './../../const/state/target';
import { submitFakeIdentity, goCreateAds, setDraft, saveDraft } from './../globalActions';
import { IdentityType, MaterialSource, videoStage } from './../../const/media';
import PopupPublishing from 'src/components/popup-publishing-new.vue';
import ads_creative from './../../store/modules/ads_creative/index';
import formHeader from 'src/components/common/form-header.vue';
import { getAccountTimezone } from './../../utils/dateUtil';
import { convert2UnifiedUTCFormat } from '@byted/tt_ads_common_utils';
import { showToast } from './../../utils/msgUtil';
import blocks from 'src/components/common/blocks.vue';
import moment from 'moment';
import { TEA_EVENT } from './../../const/state/TeaNames';
import { BudgetMode } from '@tt4b/ttam-enums';
import { reportXFmp } from './../../plugin/perfMeasurePlugin';
import * as tool from './../../utils/tool';
import { sleep } from './../../utils/creativeUtil';
import FastClick from 'fastclick';
import { useIdentityHooks, verifyIdentityStatus } from './../../hooks/global/useIdentityHooks';
const name = 'budget';
const dashboardRoute = 'perf-dashboard-detail';

export default defineComponent({
  name,
  components: {
    Popup,
    blocks,
    formHeader,
    PopupChosen,
    HeaderStepNew,
    CreationFooter,
    PopupPublishing,
  },
  props: {},
  setup() {
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const budgetRef = ref(null);
    const isReady = ref(false);
    const ifValid = ref(false);
    const showGoal = ref(false);
    const isHasFirstForm = ref(false);
    const publishing = ref(false);
    const budgetError = ref(false);
    const isAuthedLead = ref(false);
    const hasLeadAdsSigned = ref(false);
    const needGotoQualification = ref(false);
    const { aadvid } = tool.queryToJson();
    const isShowCreativeLoading = ref(false);

    const {
      stage,
      isLead,
      curGoal,
      curMode,
      endTime,
      newSelf,
      isPrepay,
      curBudget,
      startTime,
      isTraffic,
      accountInfo,
      localeTzList,
      scheduleType,
      isEngagement,
      isSelfAccount,
      startTimeDate,
      endTimeNonDate,
      budgetFormData,
      optimizeFailed,
      optimizeSucceed,
      startTimeNonDate,
      localEndTimeDate,
      localStartTimeDate,
      localEndTimeNonDate,
      currentObjectiveType,
      minBudgetDailyForGoal,
      localStartTimeNonDate,
      isNotBcChildSelfAccount,
      ifNeedGoSelfQualification,
    } = useState();
    const { useTikTokIdentity, curIdentity } = useIdentityHooks();
    watch(showGoal, () => {
      if (showGoal.value) {
        teaTracker.trackEvent(TEA_EVENT.USER_CLICK_BUDGET_GOAL_SELECTION_BUTTON);
      }
    });
    const ifShowLeadSign = computed(() => isLead.value && !ifNeedGoSelfQualification.value && !hasLeadAdsSigned.value);
    const timezone = convert2UnifiedUTCFormat(getAccountTimezone(), localeTzList.value);

    const onGoalSelection = (goal): void => {
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_ON_BUDGET_GOAL, {
        budgetGoal: goal === 109 ? 'get more followers' : 'get more profile visits',
      });
      ads_creative.mutations.setCurGoal(goal);
    };
    const showStartTime = ref(false);
    const showEndTime = ref(false);
    const onBudgetChange = (data): void => {
      ads_creative.mutations.setCurBudget(data?.toString());
    };
    const onBudgetModeChange = (mode): void => {
      teaTracker.trackEvent(TEA_EVENT.USER_SWITCH_DAILY_LIFETIME);
      mode !== BudgetMode.TOTAL_BUDGET
        ? teaTracker.trackEvent(TEA_EVENT.USER_SELECT_DAILY)
        : teaTracker.trackEvent(TEA_EVENT.USER_SELECT_LIFETIME);
      ads_creative.mutations.setCurMode(mode);
    };
    const handleScheduleSelection = (type): void => {
      type === 1
        ? teaTracker.trackEvent(TEA_EVENT.USER_CLICK_START_NOW_NO_END_DATE)
        : teaTracker.trackEvent(TEA_EVENT.USER_CLICK_SET_DATE_OPTION);
      ads_creative.mutations.setScheduleType(type);
    };
    const prefilledValue = () => {
      if (isSelfAccount.value) {
        return isTraffic.value ? 5 : 10;
      }
      return isEngagement.value ? 0 : 30;
    };
    const budgetPrefilled = {
      prefilled: true,
      prefillValueInUSD: prefilledValue(),
    };

    const cancelStartTime = (): void => {
      localStartTimeDate.value = ads_creative.getters.budgetFormData.value.startTime?.split(' ')[0];
      localStartTimeNonDate.value = ads_creative.getters.budgetFormData.value.startTime?.split(' ')[1];
      showStartTime.value = false;
    };
    const updateErrorState = (ifError): void => {
      budgetError.value = ifError;
    };
    const cancelEndTime = (): void => {
      localEndTimeDate.value = ads_creative.getters.budgetFormData.value.endTime?.split(' ')[0];
      localEndTimeNonDate.value = ads_creative.getters.budgetFormData.value.endTime?.split(' ')[1];
      showEndTime.value = false;
    };
    const updateStartTime = (): void => {
      ads_creative.mutations.setStartTime(`${localStartTimeDate.value} ${localStartTimeNonDate.value}`);
      showStartTime.value = false;
      teaTracker.trackEvent(TEA_EVENT.USER_CONFIRM_START_TIME);
    };
    const updateEndTime = (): void => {
      ads_creative.mutations.setEndTime(`${localEndTimeDate.value} ${localEndTimeNonDate.value}`);
      showEndTime.value = false;
      teaTracker.trackEvent(TEA_EVENT.USER_CONFIRM_END_TIME);
    };
    const createAds = async (optimizValidation = false): Promise<void> => {
      try {
        if (
          optimizeSucceed.value ||
          ads_creative.getters.identityFormData.value.activeSource === MaterialSource.TIKTOK_VIDEO
        ) {
          // 创意 ready
          if (!optimizValidation) {
            await goCreateAds().catch(e => {
              const { extra, msg } = e;
              let extraText = '';
              Object.keys(extra).forEach((value, index) => {
                extraText += `${Object.keys(extra)[index]}: ${extra[value]} `;
              });
              showToast({
                message: `${msg}. ${extraText} `,
              });
              Promise.reject(e);
              customBizReport('AdSubmitNew', {
                tags: { code: '-1', message: `${msg}. ${extraText}`, stage: stage.value },
              });
              throw new Error('创意有问题');
            });
          }
        } else if (!optimizeSucceed.value || optimizValidation) {
          // 创意生成中，持续的去检查是否生成成功，成功后尝试再提交
          globalLoading.hide();
          let stopPolling = false;
          await setPolling(
            async (resolve, reject) => {
              if (optimizeSucceed.value) {
                stopPolling = true;
                if (!optimizValidation) {
                  await goCreateAds().catch((err: any) => {
                    reject(err);
                  });
                }
                resolve();
              }
              if (optimizeFailed.value) {
                reject(new Error('创编提交——视频上传或生成失败'));
              }
            },
            () => stopPolling,
          );
        } else {
          throw new Error('创编提交——视频上传或生成失败');
        }
      } catch (error) {
        const report = error?.extra || error?.message;
        trackEvent('adp_waplite_impression', {
          fastcr_results_failed: typeof report === 'string' ? report : JSON.stringify(report),
        });
        if (!optimizeFailed.value) {
          // 先把弹窗关掉再弹toast
          publishing.value = false;
          globalLoading.hide();
          // campaign list超上限文案单独抛出
          const message = error?.extra?.campaign || _this.$t('module_create_ads_fail');
          // 抛出去用来阻塞后续逻辑执行
          throw new Error('创意有问题');
        }
      }
    };
    const validateAdsMaterial = async (): Promise<void> => {
      store.dispatch('budget/setPreValidation', true);
      if (!optimizeSucceed.value) {
        publishing.value = true;
      }
      await createAds(true); // 只轮询，不提交
      // this.updateDraft()
    };
    const fromBillingSubmitPayment = (): void => {
      const { query = {} } = _this.$route;
      if (accountInfo?.value.payment === paymethodTypeMap.CREDIT) {
        _this.$trackEvent(TeaConfigPayment.payment_lite_autopay_add_card, {
          payment_sourse_bindcard: 1,
        });
        _this.$trackEvent(TeaConfigPayment.payment_lite_method_choose_submit, {
          payment_type: 2,
        });
        window.onbeforeunload = null;
        // 这里是个trick，先往history中 push 下 setting 页面，这样从收银台返回的时候就会直接跳转 setting 页面
        window.history.pushState({}, '', `/wap/setting?aadvid=${aadvid}`);
        window.location.href = store.getters['payment/createUrl'];
      } else {
        _this.$trackEvent(TeaConfigPayment.payment_lite_method_choose_submit, {
          payment_type: 1,
        });
        const q = { ...query };
        delete q.from;
        // newCreate 表示
        _this.$router.push({
          name: 'purchase',
          query: { ...q, newCreate: 1 },
        });
      }
    };
    const delay = ms => new Promise(res => setTimeout(res, ms));

    const handleSubmit = async (): Promise<void> => {
      if (stage.value !== videoStage.FINISH) {
        _this.$toast(_this.$t('module_create_ads_submit_creative_load'));
        return;
      }
      await submitFakeIdentity(globalLoading);
      await createAds();
      // showBestPracticeEntry();
      // 如果创编提交报错则不执行payment相关逻辑
      if (optimizeFailed.value) {
        return;
      }
      publishing.value = false;
      await sleep(3000);
      if (isNotBcChildSelfAccount.value) {
        _this.$router.push({ name: dashboardRoute });
        return;
      }

      try {
        // 创建完发布广告后，判断是否还未首次绑卡/充值，如果没有则引导去支付页面
        // const ifPaymentValid = await store.dispatch('fastCreation/hasValidPayment');
        const ifPaymentValid = true;
        // fixme
        if (ifPaymentValid || !store.getters['account/isSelfAccount']) {
          window.location.assign(`https://ads.tiktok.com/wap/dashboard/index?aadvid=${aadvid}`);
          return;
        }
        // 打标，必须执行
        await store.dispatch['payment/getChargeInf'];
        // 后付费调用获取绑卡链接
        if (accountInfo.value.payment === paymethodTypeMap.CREDIT) {
          await store.dispatch['payment/getCardBindLink'];
        }
        if (_this.$route.query.from === 'billing') {
          fromBillingSubmitPayment();
        } else {
          if (accountInfo.value.payment === paymethodTypeMap.CREDIT) {
            window.onbeforeunload = null;
            // 这里是个trick，先往history中 push 下 setting 页面，这样从收银台返回的时候就会直接跳转 setting 页面
            window.history.pushState({}, '', `/wap/setting?aadvid=${aadvid}`);
            window.location.href = store.getters['payment/createUrl'];
          } else {
            _this.$router.push({ name: 'purchase' });
          }
        }
      } catch (e) {
        // _this.$router.push({ name: dashboardRoute })
      } finally {
        publishing.value = false;
        ads_creative.mutations.init();
      }
    };
    const headerNext = async (): Promise<void> => {
      if (useTikTokIdentity.value && curIdentity.value?.identity_type === IdentityType.TT_USER) {
        const { identity_type, identity_id } = curIdentity?.value;
        const ifAvailable = await verifyIdentityStatus(identity_type, identity_id);
        if (!ifAvailable) {
          _this.$toast(_this.$t('fastcreation_identity_invalid_desc'));
          return;
        }
      }
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_PUBLISH, { source: 'new', objective_type: currentObjectiveType.value });
      // check if user selecting video library, or updated material with unavailable tiktok identity

      await saveDraft();
      try {
        await budgetRef.value.validate();
      } catch (e) {
        teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
          source: 'new',
          submit_result: 'budget validation failed',
          objective_type: currentObjectiveType.value,
        });
        isShowCreativeLoading.value = false;
        return;
      }
      if (!isReady.value) {
        isShowCreativeLoading.value = false;
        return;
      }
      if (isLead.value && !hasLeadAdsSigned.value) {
        try {
          await signLeadAdsProtocal();
        } catch (e) {
          console.log('failed sign lead');
        }
      }
      if (needGotoQualification.value && newSelf && isHasFirstForm.value) {
        teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
          source: 'new',
          submit_result: 'moved to qualification',
          objective_type: currentObjectiveType.value
        });
        // 先去提交资质await
        isShowCreativeLoading.value = false;
        try {
          _this.$router.push({ name: 'qualification', query: { from: 'budget' } });
          return;
        } catch (error) {
          _this.$router.push({ name: 'budget' });
        }
      }
      try {
        // 自助 + 在强制支付白名单里 + 支付验证失败
        if (isNotBcChildSelfAccount.value && !ifValid.value) {
          await validateAdsMaterial();
          try {
            if (isPrepay.value) {
              _this.$router.push({ name: 'purchase', query: { from: 'budget' } });
              return;
            }

            // 获取后付费绑卡链接
            await store.dispatch('payment/getCardBindLink');
            window.onbeforeunload = null;
            window.history.pushState({}, '', `/wap/budget?aadvid=${aadvid}&from=payment`);
            const baseUrl = store.getters['payment/createUrl'].split('&redirect')[0];
            const redirectLink = encodeURIComponent('/wap/budget?from=payment');
            window.location.href = `${baseUrl}&redirect=${redirectLink}&cancel_redirect=${redirectLink}`;
            teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
              source: 'new',
              submit_result: 'payment_not_ready',
              objective_type: currentObjectiveType.value
            });
            return;
          } catch (e) {
            teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
              source: 'new',
              submit_result: 'payment_not_ready',
              objective_type: currentObjectiveType.value
            });
            _this.$router.push({ name: 'budget' });
          }
        }

        if (publishing.value) {
          return;
        }

        // TODO draft_type必须要是“fast_creation”或者“billing”之一，传入none会报50002错
        // this.updateDraft().then(() => this.setDraftType(DraftType.none))

        /**
         * fake identity提交报错交互，弹toast
         * tt post有效性校验移除，改为由后端校验拦截，原因是前端处理起来比较麻烦，得多次拉取原生素材列表接口挨个比对
         * TODO：线上后端接口报错拦截的交互场景，都是先出创意视频生成成功的弹窗，然后出toast提示报错。如果要优化，建议统一处理，而非仅仅处理tt素材校验这一种场景。
         */

        isShowCreativeLoading.value = true;
        publishing.value = true;

        await handleSubmit();
        customBizReport('AdSubmitNew', { tags: { code: '0' } });
        teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
          source: 'new',
          submit_result: 'success',
          objective_type: currentObjectiveType.value
        });
      } catch (error) {
        teaTracker.trackEvent(TEA_EVENT.SUCCESS_PUBLISH, {
          source: 'new',
          submit_result: 'other_errors',
          objective_type: currentObjectiveType.value
        });
      } finally {
        isShowCreativeLoading.value = false;
      }
    };
    const focusReport = () => {
      teaTracker.trackEvent(TEA_EVENT.USER_INPUT_BUDGET);
    };
    const handleShowStart = () => {
      showStartTime.value = true;
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_START_TIME);
      teaTracker.trackEvent(TEA_EVENT.DISPLAY_START_TIME_POP);
    };
    const handleShowEnd = () => {
      showEndTime.value = true;
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_END_TIME);
      teaTracker.trackEvent(TEA_EVENT.DISPLAY_END_TIME_POP);
    };
    const processDraft = async () => {
      try {
        _this.$Loading.show();
        isReady.value = true;
        const { data } = await getLeadAdsProtocal();
        const {
          data: draftData = {
            draft_json: {},
          },
        } = await getDraft();
        hasLeadAdsSigned.value = Boolean(data?.lead_gen_signed);
        isAuthedLead.value = Boolean(data?.lead_gen_signed);
        if (ifNeedGoSelfQualification.value) {
          needGotoQualification.value = true;
          isHasFirstForm.value = await store.dispatch('qualification/initQualificationForm');
        }
        if (isNotBcChildSelfAccount.value) {
          ifValid.value = await store.dispatch('fastCreation/hasValidPayment');
          await store.dispatch('payment/getChargeInfo');
        }
        if (!ifValid.value && _this.$route.query.from === 'billing') {
          _this.$Loading.hide();
          headerNext();
        } else if (
          !ifValid.value ||
          !(_this.$route.query.from === 'purchase' || _this.$route.query.from === 'payment')
        ) {
          _this.$Loading.hide();
          globalLoading.hide();
        }
        if (
          (_this.$route.query.from === 'purchase' || _this.$route.query.from === 'payment') &&
          isNotBcChildSelfAccount
        ) {
          const { draft_json = {} } = draftData;
          setDraft(draft_json);
          if (ifValid.value || !isSelfAccount.value) {
            headerNext();
          }
          _this.$Loading.hide();
          delete _this.$route.query.from;
        }
      } catch (e) {
        _this.$Loading.hide();
      }
    };
    onMounted(async () => {
      reportXFmp();
      teaTracker.trackEvent(TEA_EVENT.DISPLAY_BUDGET, { source: 'new', objective_type: currentObjectiveType.value });
      const nodeList = document.querySelectorAll('.budget-container_items');
      nodeList.forEach(el => {
        new FastClick(el);
      });
      await processDraft();
      _this.$Loading.hide();
    });

    return {
      name,
      isLead,
      curGoal,
      stage,
      focusReport,
      handleShowStart,
      handleShowEnd,
      endTime: computed(() => moment(endTime.value).format('YYYY-MM-DD HH:mm:ss')),
      curMode,
      timezone,
      budgetRef,
      ifShowLeadSign,
      isAuthedLead,
      startTime: computed(() => moment(startTime.value).format('YYYY-MM-DD HH:mm:ss')),
      showGoal,
      curBudget,
      headerNext,
      publishing,
      showEndTime,
      scheduleType,
      isEngagement,
      updateEndTime,
      cancelEndTime,
      showStartTime,
      startTimeDate,
      budgetFormData,
      endTimeNonDate,
      onBudgetChange,
      onGoalSelection,
      cancelStartTime,
      budgetPrefilled,
      updateStartTime,
      hasLeadAdsSigned,
      localEndTimeDate,
      startTimeNonDate,
      updateErrorState,
      localStartTimeDate,
      onBudgetModeChange,
      OptimizeGoalOptionsForBudget,
      localEndTimeNonDate,
      minBudgetDailyForGoal,
      needGotoQualification,
      localStartTimeNonDate,
      handleScheduleSelection,
      isShowCreativeLoading,
    };
  },
});
